// ClickHouse's default DateTime64 wire format is `"YYYY-MM-DD HH:MM:SS[.fff]"`
// with no timezone marker. ECMAScript's `Date.parse` / `new Date(string)`
// treat such strings as *local* time, so a UTC instant on the server lands
// in the dashboard double-shifted: the formatter then renders it in local
// time, which surfaces as the UTC clock value labeled as if it were local.
// Normalize to ISO-8601 with a `Z` suffix so the parse produces the correct
// epoch; strings that already carry a timezone marker pass through unchanged.
export function parseServerTimestamp(value) {
  if (value == null) return NaN;
  if (typeof value === "number") return value;
  const str = String(value).trim();
  if (!str) return NaN;
  if (/(?:Z|[+-]\d{2}:?\d{2})$/i.test(str)) return Date.parse(str);
  return Date.parse(str.replace(" ", "T") + "Z");
}

export const timeLabelFormatter = new Intl.DateTimeFormat("en-US", {
  hour: "numeric",
  minute: "2-digit",
});

export const dayLabelFormatter = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
});

export const fullTimestampFormatter = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
});

export function buildPlotConfig(activityLens, windowItem, palette) {
  if (activityLens === "prompts") {
    return {
      layers: windowItem.promptLayers,
      stroke: palette.neutral,
      legend: windowItem.promptLayers,
    };
  }
  if (activityLens === "tokens") {
    return {
      layers: windowItem.tokenLayers,
      stroke: palette.neutral,
      legend: windowItem.tokenLayers,
      // Estimated USD cost summary (total + per-model) for the token lens;
      // the chart legend shows the total and each layer's hover its share.
      cost: windowItem.tokenCost,
    };
  }
  if (activityLens === "endpoints") {
    return {
      layers: windowItem.endpointsLayers,
      stroke: palette.neutral,
      legend: windowItem.endpointsLayers,
    };
  }
  if (activityLens === "clusters") {
    return { swimlane: true };
  }
  return {
    layers: windowItem.activityLayers,
    stroke: palette.neutral,
    legend: windowItem.activityLayers,
  };
}
